module.exports = __webpack_public_path__ + "static/media/csmMetaImage.a5048ab3.png";